import ReverseCrossIcon from './component'

export default ReverseCrossIcon
